<template>
    <div class="NoEntitiesFound">
        <img :src="noResultsImage" alt="no entities found">
        <strong>No Matching Search results</strong>
        <span>Try again using other filter combinations</span>
        <NewButton color="primary" @click="$emit('reset')">
            Clear search
        </NewButton>
    </div>
</template>

<style lang="scss">
    .NoEntitiesFound {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #778ea1;

        strong {
            font-size: 16px;
        }

        span {
            font-size: 14px;
        }

        img {
            margin-bottom: 15px;
        }
    }
</style>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import NewButton from '@/components/new-button/NewButton.vue';
    import noResultsImage from '@/modules/entity-filtering/assets/entityFiltering-image-noResults.svg';

    @Component({
        emits: [ 'reset' ],
        components: { NewButton },
    })
    export default class NoEntitiesFound extends Vue {
        private noResultsImage = noResultsImage;
    }
</script>
